import { render, staticRenderFns } from "./RegisteredLender.vue?vue&type=template&id=70e25146&scoped=true"
var script = {}
import style0 from "./RegisteredLender.vue?vue&type=style&index=0&id=70e25146&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "70e25146",
  null
  
)

export default component.exports